// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6529":"23c3f01cc3a4cdfc","8723":"235d186fc1d2bed5"}[chunkId] + ".js";
};